import axios from 'axios';
import router from '../router/index';

let request = null;

class Api {
  initAxios() {
    request = axios.create({
      baseURL: process.env.VUE_APP_API_ENDPOINTS,
      headers: {
        Authorization: `Bearer TODO`,
      },
    });

    request.interceptors.response.use(
      function (response) {
        return response;
      },
      function (error) {
        router.push('/error');
        return Promise.reject(error);
      }
    );
  }

  sendEmail(body) {
    return request.post('email/' + window.sessionStorage.getItem('storeId'), null, {
      params: {
        message: body,
      },
    });
  }

  acceptCgu() {
    return request.post('account/' + window.sessionStorage.getItem('storeId') + '/acceptcgu');
  }

  updateProducts(body) {
    return request.put('account/' + window.sessionStorage.getItem('storeId'), body);
  }

  getGammes() {
    /** 
    * ! for local development
    * ! - comment request.get('account/' + window.sessionStorage.getItem('storeId'))
    * ! - uncomment axios.get('/db.json')
    */
    return request.get('account/' + window.sessionStorage.getItem('storeId'));
    // return axios.get('/db.json');
  }

  getWebControls() {
    /** 
    * ! for local development
    * ! - comment request.get(process.env.VUE_APP_API_WEBCONTROL)
    * ! - uncomment axios.get('/WebControl.json')
    */
    return request.get(process.env.VUE_APP_API_WEBCONTROL);
    // return axios.get('/WebControl.json');
  }

  getMedias() {
    /** 
    * ! for local development
    * ! - comment request.get(process.env.VUE_APP_API_MEDIA)
    * ! - uncomment axios.get('/Media.json')
    */
    return request.get(process.env.VUE_APP_API_MEDIA);
    // return axios.get('/Media.json');
  }

  getVisionCategory() {
    /** 
    * ! for local development
    * ! - comment request.get(process.env.VUE_APP_API_UNDERSTAND)
    * ! - uncomment axios.get('/VisionCategory.json')
    */
    return request.get(process.env.VUE_APP_API_UNDERSTAND);
    // return axios.get('/VisionCategory.json');
  }

  getProduct() {
    /** 
    * ! for local development
    * ! - comment request.get(process.env.VUE_APP_API_PRODUCT + '/?accountId=' + window.sessionStorage.getItem('storeId'))
    * ! - uncomment axios.get('Product.json')
    */
    return request.get(process.env.VUE_APP_API_PRODUCT + '/?userID=' + window.sessionStorage.getItem('storeId'));
    // return axios.get('Product.json');
  }
}

export default new Api();
